import React from "react";
import GalleryPieceNotFoundContainer from "../containers/gallery-piece-not-found-container";

const GalleryPieceNotFoundPage = () => (
  <main className="gallery-piece-not-found=page">
    <GalleryPieceNotFoundContainer />
  </main>
);

export default GalleryPieceNotFoundPage;
